import { render, staticRenderFns } from "./FillFileNum.vue?vue&type=template&id=5f5248ae"
import script from "./FillFileNum.vue?vue&type=script&lang=js"
export * from "./FillFileNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports